import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import SeoLandingPagePremium from "@/pages/seo/SeoLandingPagePremium";
import ProfessionLandingPage from "@/pages/seo/ProfessionLandingPage";
import AdminDashboard from "@/pages/AdminDashboard";
import { generateSeoRoutes, generateProfessionRoutes, getServiceContent } from "@/data/seoData";

// Generate all routes dynamically
const seoRoutes = generateSeoRoutes();
const professionRoutes = generateProfessionRoutes();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Main site */}
        <Route path="/" element={<App />} />
        
        {/* Admin Dashboard - noindex */}
        <Route path="/admin" element={<AdminDashboard />} />
        
        {/* Dynamic SEO Landing Pages - Services */}
        {seoRoutes.map((route) => {
          // Ottieni contenuti specifici per città/servizio
          const customContent = getServiceContent(route.serviceId, route.cityId);
          const slug = route.path.substring(1);
          
          return (
            <Route 
              key={route.path}
              path={route.path}
              element={
                <SeoLandingPagePremium 
                  city={route.city}
                  cityId={route.cityId}
                  region={route.region}
                  serviceId={route.serviceId}
                  slug={slug}
                  metaTitle={customContent?.metaTitleTemplate?.replace("{city}", route.city) || route.metaTitle}
                  metaDescription={customContent?.metaDescTemplate?.replace("{city}", route.city) || route.metaDescription}
                  heroTitle={customContent?.heroTitle || route.heroTitle}
                  heroHighlight={customContent?.heroHighlight || route.heroHighlight}
                  heroSubtitle={customContent?.heroSubtitle || route.heroSubtitle}
                  localBusinesses={route.localBusinesses}
                  localAreas={route.localAreas}
                  nearCities={route.nearCities}
                  localContext={route.localContext}
                  customContent={customContent}
                />
              }
            />
          );
        })}
        
        {/* Dynamic SEO Landing Pages - Professions */}
        {professionRoutes.map((route) => (
          <Route 
            key={route.path}
            path={route.path}
            element={
              <ProfessionLandingPage 
                city={route.city}
                region={route.region}
                profession={route.profession}
                professionId={route.professionId}
                category={route.category}
                slug={route.path.substring(1)}
                metaTitle={route.metaTitle}
                metaDescription={route.metaDescription}
                heroTitle={route.heroTitle}
                heroHighlight={route.heroHighlight}
                heroSubtitle={route.heroSubtitle}
                targetDescription={route.targetDescription}
                painPoints={route.painPoints}
                benefits={route.benefits}
                professionServices={route.professionServices}
                localAreas={route.localAreas}
                nearCities={route.nearCities}
                localContext={route.localContext}
              />
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
